<template>
<nav id="site-navigation" class="has-branding main-navigation nav-align-right sub-menu-right" aria-label="Primary" itemtype="https://schema.org/SiteNavigationElement" itemscope>
  <div class="inside-navigation">
    <div class="navigation-branding">
      <div class="site-logo">
        <router-link to="/" title="GB WhatsApp" rel="home" class="text-logo">
          <img src="@/assets/gb-logo.png" alt="GB WhatsApp" class="logo-icon" width="44" height="44" />
        </router-link>
      </div>
      <p class="main-title" itemprop="headline">
        <router-link to="/" rel="home">GBWhatsApp</router-link>
      </p>
    </div>

    <ul
      id="menu-primary-menu"
      class="menu sf-menu mobile-menu-page"
      v-show="isMenuClicked"
    >
      <li
        v-for="item in navItems"
        :key="item.label"
        class="menu-item"
        :class="{ 'has-dropdown': item.children, 'is-open': openDropdown === item.label }"
      >
        <template v-if="item.children">
          <button type="button" class="dropdown-trigger" @click="toggleDropdown(item.label)">
            {{ item.label }}
            <span class="dropdown-arrow" aria-hidden="true">▾</span>
          </button>
          <ul class="sub-menu site-nav-dropdown">
            <li v-for="child in item.children" :key="child.to" class="nav-dropdown-item">
              <router-link :to="child.to" @click.native="closeMenus">{{ child.label }}</router-link>
            </li>
          </ul>
        </template>
        <router-link v-else :to="item.to" :exact="item.exact" @click.native="closeMenus">{{ item.label }}</router-link>
      </li>
      <li class="menu-item header-download">
        <router-link to="/gb-whatsapp-latest-version/" class="download-btn" @click.native="closeMenus">Get APK</router-link>
      </li>
    </ul>

    <div id="primary-menu" class="main-nav">
      <div class="mobile-menu" v-if="$global.isMobileDevice()">
        <div class="menu-toggle" @click="isMenuClicked=!isMenuClicked">
          <img src="@/assets/menu.svg" alt="menu button" v-if="!isMenuClicked">
          <img src="@/assets/xmark-black.svg" alt="close button" v-else>
        </div>
      </div>
      <ul v-else id="menu-primary-menu-desktop" class="menu sf-menu">
        <li
          v-for="item in navItems"
          :key="'d-' + item.label"
          class="menu-item"
          :class="{ 'has-dropdown': item.children }"
        >
          <template v-if="item.children">
            <span class="dropdown-trigger">
              {{ item.label }}
              <span class="dropdown-arrow" aria-hidden="true">▾</span>
            </span>
            <ul class="sub-menu site-nav-dropdown">
              <li v-for="child in item.children" :key="child.to" class="nav-dropdown-item">
                <router-link :to="child.to">{{ child.label }}</router-link>
              </li>
            </ul>
          </template>
          <router-link v-else :to="item.to" :exact="item.exact">{{ item.label }}</router-link>
        </li>
        <li class="menu-item header-download">
          <router-link to="/gb-whatsapp-latest-version/" class="download-btn">Get APK</router-link>
        </li>
      </ul>
    </div>
  </div>
</nav>
</template>

<script>
const NAV_ITEMS = [
  { label: 'Home', to: '/', exact: true },
  { label: 'Install Guide', to: '/gb-whatsapp-install/' },
  {
    label: 'Troubleshooting',
    children: [
      { label: 'Not Installing', to: '/gb-whatsapp-not-installing/' },
      { label: 'Not Connecting', to: '/gb-whatsapp-not-connecting/' },
      { label: 'OTP Not Received', to: '/gb-whatsapp-otp-not-received/' },
      { label: 'Update Failed', to: '/gb-whatsapp-update-failed/' },
      { label: 'Restore Backup', to: '/gb-whatsapp-restore-backup/' },
      { label: 'Banned Account Fix', to: '/gb-whatsapp-banned-account-fix/' },
    ],
  },
  {
    label: 'Comparison',
    children: [
      { label: 'GB WhatsApp vs WhatsApp', to: '/gb-whatsapp-vs-whatsapp/' },
      { label: 'GB WhatsApp vs FM WhatsApp', to: '/gb-whatsapp-vs-fm-whatsapp/' },
      { label: 'GB WhatsApp vs YoWhatsApp', to: '/gb-whatsapp-vs-yowhatsapp/' },
      { label: 'GB WhatsApp vs WhatsApp Plus', to: '/gb-whatsapp-vs-whatsapp-plus/' },
    ],
  },
  {
    label: 'Safety',
    children: [
      { label: 'Is GB WhatsApp Safe', to: '/is-gb-whatsapp-safe/' },
      { label: 'Is GB WhatsApp Legal', to: '/is-gb-whatsapp-legal/' },
    ],
  },
];

export default {
  props: {
    selectedLanguage: {
      type: String,
      required: true,
    },
    page: {
      type: String,
      required: true,
    },
    gotodownload: {
      type: Function,
    },
    apk: {
      type: Object,
    },
  },
  data() {
    return {
      isMenuClicked: false,
      openDropdown: null,
      navItems: NAV_ITEMS,
    };
  },
  methods: {
    toggleDropdown(label) {
      this.openDropdown = this.openDropdown === label ? null : label;
    },
    closeMenus() {
      this.isMenuClicked = false;
      this.openDropdown = null;
    },
  },
};
</script>

<style lang="scss" scoped>
#site-navigation {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);

  .inside-navigation {
    width: 80%;
    margin: 0 auto;
    z-index: 9999;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.text-logo {
  text-decoration: none;

  .logo-icon {
    display: block;
    width: 44px;
    height: 44px;
    object-fit: contain;
    flex-shrink: 0;
  }
}

.main-nav {
  .menu {
    list-style-type: none !important;
    margin: 0 !important;
    padding: 0;
    display: flex;
    align-items: center;
    gap: 4px;

    > .menu-item {
      position: relative;
      list-style: none;
    }

    > .menu-item > a:not(.download-btn),
    > .menu-item > .dropdown-trigger {
      font-weight: 500 !important;
      color: #333;
      text-decoration: none;
      padding: 8px 10px;
      border-radius: 6px;
      font-size: 14px;
      line-height: 1.4 !important;
      display: inline-flex;
      align-items: center;
      gap: 4px;
      white-space: nowrap;
      background: none;
      border: none;
      cursor: pointer;
      font-family: inherit;
      transition: color 0.2s, background 0.2s;
    }

    > .menu-item > a:not(.download-btn):hover,
    > .menu-item > .dropdown-trigger:hover,
    .has-dropdown:hover > .dropdown-trigger {
      color: #128C7E;
      background: #f3fbf6;
    }

    > .menu-item > a.router-link-exact-active:not(.download-btn) {
      color: #128C7E;
      background: #e9f7ef;
    }

    > .menu-item.header-download > a.download-btn {
      background: linear-gradient(135deg, #25D366, #128C7E) !important;
      color: #fff !important;
      border-radius: 20px !important;
      padding: 8px 16px !important;
      line-height: 1.4 !important;
      font-weight: 600 !important;

      &:hover {
        color: #fff !important;
        background: linear-gradient(135deg, #25D366, #128C7E) !important;
        opacity: 0.92;
      }
    }

    .dropdown-arrow {
      font-size: 13px;
      opacity: 0.75;
      transition: transform 0.2s;
    }

    .has-dropdown:hover .dropdown-arrow {
      transform: rotate(180deg);
    }

    // 桌面端下拉面板
    .has-dropdown .site-nav-dropdown {
      display: none;
      position: absolute;
      top: calc(100% + 8px);
      left: 50%;
      transform: translateX(-50%);
      width: max-content;
      min-width: 200px;
      max-width: 300px;
      margin: 0 !important;
      padding: 8px !important;
      list-style: none !important;
      background: #fff;
      border-radius: 12px;
      box-shadow: 0 12px 32px rgba(7, 94, 84, 0.15);
      border: 1px solid #e0efe8;
      z-index: 1000;
      flex-direction: column;
      gap: 4px;

      // 小三角指向父菜单
      &::before {
        content: '';
        position: absolute;
        top: -6px;
        left: 50%;
        transform: translateX(-50%) rotate(45deg);
        width: 10px;
        height: 10px;
        background: #fff;
        border-left: 1px solid #e0efe8;
        border-top: 1px solid #e0efe8;
      }
    }

    // 悬停桥接区，防止鼠标移入时菜单消失
    .has-dropdown::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      top: 100%;
      height: 10px;
    }

    .has-dropdown:hover .site-nav-dropdown {
      display: flex;
      animation: navDropdownIn 0.2s ease;
    }
  }
}

@keyframes navDropdownIn {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

@media screen and (max-width: 768px) {
  .inside-navigation {
    .mobile-menu-page {
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      width: 100%;
      z-index: 1001;
      margin: 0 !important;
      padding: 0;
      background: #fff;
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);

      .menu-item {
        margin-bottom: 0 !important;
        background: #fff;
        border-bottom: 1px solid #f0f0f0;

        > a:not(.download-btn),
        > .dropdown-trigger {
          width: 100%;
          justify-content: center;
          font-size: 15px;
          text-align: center;
          color: #121212;
          padding: 14px 16px;
        }

        .dropdown-trigger {
          display: flex;
        }

        .site-nav-dropdown {
          display: none;
          margin: 0 !important;
          padding: 8px 12px 10px !important;
          list-style: none !important;
          background: #f8fdf9;
          position: static !important;
          transform: none !important;
          box-shadow: none !important;
          border: none !important;
          border-radius: 0 !important;
          flex-direction: column;
          gap: 4px;

          &::before {
            display: none;
          }

          .nav-dropdown-item + .nav-dropdown-item {
            margin-top: 2px;
          }

          a {
            display: block !important;
            padding: 11px 16px !important;
            line-height: 1.4 !important;
            font-size: 14px;
            text-align: center;
            color: #333;
            border-radius: 8px;
          }
        }

        &.is-open .site-nav-dropdown {
          display: flex;
        }

        &.header-download > a.download-btn {
          background: linear-gradient(135deg, #25D366, #128C7E) !important;
          color: #fff !important;
          border-radius: 20px !important;
          margin: 10px auto;
          width: auto;
          display: inline-flex !important;
        }
      }
    }
  }

  .main-nav {
    flex: 1;
    margin-right: 10px;

    .mobile-menu {
      display: flex;
      justify-content: flex-end;

      .menu-toggle {
        display: flex;
        justify-content: center;
        padding: 12px;
        cursor: pointer;

        img {
          width: 23px;
          height: 23px;
        }
      }
    }
  }
}
</style>

<!-- 覆盖全局 base.scss 对导航链接 line-height:60px 的影响 -->
<style lang="scss">
/* 默认隐藏所有下拉，避免全局样式导致全部展开 */
#site-navigation .site-nav-dropdown {
  display: none !important;
  margin: 0 !important;
  padding: 8px !important;
  list-style: none !important;
  flex-direction: column;
  gap: 4px;
}

/* 桌面端：悬停对应菜单项时才显示 */
#site-navigation .main-nav .menu-item.has-dropdown:hover > .site-nav-dropdown {
  display: flex !important;
}

/* 移动端：点击展开时才显示 */
#site-navigation .mobile-menu-page .menu-item.is-open > .site-nav-dropdown {
  display: flex !important;
}

#site-navigation .site-nav-dropdown .nav-dropdown-item {
  list-style: none !important;
  margin: 0 !important;
  padding: 0 !important;
}

#site-navigation .site-nav-dropdown .nav-dropdown-item + .nav-dropdown-item {
  margin-top: 2px !important;
}

#site-navigation .site-nav-dropdown .nav-dropdown-item a {
  display: block !important;
  padding: 10px 14px !important;
  margin: 0 !important;
  line-height: 1.45 !important;
  font-size: 13.5px !important;
  font-weight: 500 !important;
  color: #2d3748 !important;
  white-space: nowrap;
  border-radius: 8px;
  transition: background 0.15s, color 0.15s;
}

#site-navigation .site-nav-dropdown .nav-dropdown-item a:hover {
  background: #e9f7ef !important;
  color: #075E54 !important;
}

#site-navigation .site-nav-dropdown .nav-dropdown-item a.router-link-active {
  color: #128C7E !important;
  background: #e9f7ef !important;
  font-weight: 600 !important;
}

/* 覆盖 index.scss / base.scss 对 Get APK 按钮的全局样式 */
#site-navigation .main-nav .header-download a.download-btn,
#site-navigation .mobile-menu-page .header-download a.download-btn {
  background: linear-gradient(135deg, #25D366, #128C7E) !important;
  color: #fff !important;
  border-radius: 20px !important;
  padding: 8px 16px !important;
  line-height: 1.4 !important;
  font-weight: 600 !important;
}

#site-navigation .main-nav .header-download a.download-btn:hover,
#site-navigation .mobile-menu-page .header-download a.download-btn:hover {
  color: #fff !important;
  background: linear-gradient(135deg, #25D366, #128C7E) !important;
  opacity: 0.92;
}

#site-navigation .dropdown-arrow {
  font-size: 13px;
  opacity: 0.75;
  margin-left: 3px;
  transition: transform 0.2s;
}

#site-navigation .has-dropdown:hover > .dropdown-trigger .dropdown-arrow {
  transform: rotate(180deg);
}
</style>

